import DOMPurify from 'dompurify';
import { LEAD_REGISTRATION_API, BRANDID } from './constants';
import { getCookieValue, setCookie } from './cookie';
import {
  isLeadInfoValid, pushRegInfoToGTM, phoneValidator, showPlansFold,
  setPhoneFlagAttribute, highlightInvalidFields,
} from '../util/registerUtil';
import { emitTapNativeConversionEventIfApplicable, isTapNativeCookiePresent } from './tapNativeTracker';

let leadInfo = {};
let associationsLeadInfo = {};
let btmPpcleadInfo = {};
const registerBtn = document.querySelector('#register');
const btmPpcregisterBtn = document.querySelector('#btm-ppc-register');
const associateRegisterBtn = document.querySelector('#associate-register-btn');
const inquiryDetailsCookie = getCookieValue('inquiryDetails');
const registerLpFrom = document.querySelector('.register-lp');
const btmRegisterLpForm = document.querySelector('.register-lp.btm-form');
const isReferAFriendPage = window.location.pathname.includes('redeem-your-referral');
const isFromAMSPAPage = document.referrer.includes('/why/associations/amspa') || window.location.pathname.includes('/why/associations/amspa');
const isFromJoepopPage = document.referrer.includes('/joe') || window.location.pathname.includes('/joe');
const isFromStartupNationPage = document.referrer.includes('/startupnation') || window.location.pathname.includes('/startupnation');
const isFromIgniteDDSPage = document.referrer.includes('/ignitedds') || window.location.pathname.includes('/ignitedds');
const isFromAANPPage = document.referrer.includes('/why/associations/aanp') || window.location.pathname.includes('/why/associations/aanp');
const isFromNAHCPage = document.referrer.includes('/why/associations/nahc') || window.location.pathname.includes('/why/associations/nahc');
const isFromTdaMeeting = document.referrer.includes('/lp/tda-meeting') || window.location.pathname.includes('/lp/tda-meeting');
const isFromAANPAnnualConvention = document.referrer.includes('/lp/aanp-annual-convention') || window.location.pathname.includes('/lp/aanp-annual-convention');
const isFromACAPage = document.referrer.includes('/why/associations/aca') || window.location.pathname.includes('/why/associations/aca');
const isFromAADOMPage = document.referrer.includes('/why/associations/aadom') || window.location.pathname.includes('/why/associations/aadom');
const isFromMcCancePage = document.referrer.includes('/mccance') || window.location.pathname.includes('/mccance');
const isFromDentalpreneurPage = document.referrer.includes('/dentalpreneur') || window.location.pathname.includes('/dentalpreneur');
const isFromPartnershipPages = isFromAANPPage
  || isFromAMSPAPage
  || isFromACAPage
  || isFromAADOMPage
  || isFromNAHCPage;

const isFromLpPages = ['/lp', '/aaos', '/startupnation', '/joe', 'why/associations', '/lp/online-receptionist-live-phone-answering', '/ignitedds', '/lp/aanp-annual-convention', '/mccance']
  .some(path => window.location.pathname.startsWith(path));

const fiftyPercentOfftillThreePlanPaths = ['/aaos', '/joe', '/startupnation', '/ignitedds', '/mccance', '/dentalpreneur'];
function onFocus(event) {
  if (event.target.classList.contains('is-valid')) {
    event.target.classList.remove('is-valid');
  }
  if (event.target.classList.contains('is-err')) {
    event.target.classList.remove('is-err');
  }
  const elementFocused = event.target;
  if (elementFocused.id === 'phone' || elementFocused.id === 'association-lead-phone' || elementFocused.id === 'btm-ppc-phone') {
    let phoneValidElem;
    let phoneInValidElem;
    if (elementFocused.id === 'phone') {
      phoneValidElem = document.getElementById('phone-valid');
      phoneInValidElem = document.getElementById('phone-invalid');
    } else if (elementFocused.id === 'association-lead-phone') {
      phoneValidElem = document.getElementById('associate-phone-valid');
      phoneInValidElem = document.getElementById('associate-phone-invalid');
    } else if (elementFocused.id === 'btm-ppc-phone') {
      phoneValidElem = document.getElementById('ppc-phone-valid');
      phoneInValidElem = document.getElementById('ppc-phone-invalid');
    }
    phoneInValidElem.setAttribute('style', 'display:none;');
    phoneValidElem.setAttribute('style', 'display:none;');
  }
}

function onBlur(event, info) {
  const targetId = event.target.id;
  if (info.valid && DOMPurify.sanitize(info.value) === info.value) {
    document.querySelector(info.selector).classList.add('is-valid');
  } else {
    // eslint-disable-next-line no-param-reassign
    info.valid = false;
    document.querySelector(info.selector).classList.remove('is-valid');
    document.querySelector(info.selector).classList.add('is-err');
  }
  if (targetId.includes('association')) {
    associationsLeadInfo[info.emittedBy] = info;
  } else if (targetId.includes('btm')) {
    btmPpcleadInfo[info.emittedBy] = info;
  } else {
    leadInfo[info.emittedBy] = info;
  }

  const elementFocused = event.target;
  if (elementFocused.id === 'phone' || elementFocused.id === 'association-lead-phone' || elementFocused.id === 'btm-ppc-phone') {
    phoneValidator(elementFocused);
  }
}

function leadInfoObject(phoneFieldID, emailFieldID, nameFieldID) {
  return {
    fields: {
      phone: {
        selector: phoneFieldID,
        type: 'phone',
        withDialCodePicker: true,
        country: (window.siteInfo && window.siteInfo.country) || 'US',
        errorClassName: 'is-err',
        rightClassName: 'is-valid',
      },
      mail: {
        selector: emailFieldID, type: 'email', errorClassName: 'is-err', rightClassName: 'is-valid',
      },
      name: {
        selector: nameFieldID, type: 'text', errorClassName: 'is-err', rightClassName: 'is-valid',
      },
    },
    eventListeners: {
      blur: onBlur,
      focus: onFocus,
    },
  };
}

leadInfo = window.InputValidator
        && window.InputValidator.fields.initialize({ ...leadInfoObject('#phone', '#email', '#name') });


btmPpcleadInfo = window.InputValidator
        && window.InputValidator.fields.initialize({ ...leadInfoObject('#btm-ppc-phone', '#btm-ppc-email', '#btm-ppc-name') });

associationsLeadInfo = window.InputValidator && window.InputValidator.fields.initialize({
  ...leadInfoObject('#association-lead-phone', '#association-lead-email', '#association-lead-name'),
});

if (inquiryDetailsCookie) {
  const inquiryDetails = JSON.parse(inquiryDetailsCookie);
  document.querySelector('#name').value = inquiryDetails.name;
  // document.querySelector('#company').value = inquiryDetails.company;
  document.querySelector('#email').value = inquiryDetails.mail;
}
function successCallback() {
  const referrerUrl = new window.URL(
    document.referrer || window.location.href,
  );

  const applyFiftyPercentOfftillThreePlan = fiftyPercentOfftillThreePlanPaths
    .some(path => referrerUrl.pathname.startsWith(path));

  if (referrerUrl && (referrerUrl.pathname.startsWith('/lp/smilecon') || referrerUrl.pathname.startsWith('/lp/mhm'))) {
    setCookie('fiftyPercentOff', true, 365);
  }
  if (referrerUrl && (referrerUrl.pathname.startsWith('/lp/aaos-annual-meeting') || referrerUrl.pathname.startsWith('/lp/tda-meeting') || referrerUrl.pathname.startsWith('/lp/aanp-annual-convention'))) {
    setCookie('thirtyPercentOff', true, 365);
  }
  if (referrerUrl && applyFiftyPercentOfftillThreePlan) {
    setCookie('tillThreePlan', true, 365);
  }
  if (isFromPartnershipPages) {
    setCookie('isFromPartnershipPages', true, 365);
  }
  if (isFromTdaMeeting) {
    setCookie('isFromTdaMeeting', true, 365);
  }
  if (isFromAANPAnnualConvention) {
    setCookie('isFromAANPAnnualConvention', true, 365);
  }
  emitTapNativeConversionEventIfApplicable();
}

if (isFromLpPages || isReferAFriendPage) {
  const isregistered = getCookieValue('isregistered');
  if (isregistered && registerLpFrom && btmRegisterLpForm) {
    registerLpFrom.classList.add('is-registered');
    btmRegisterLpForm.classList.add('is-registered');
  }
}

async function processLeadRegistration(payload) {
  try {
    let response = await window.fetch(LEAD_REGISTRATION_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    response = await response.json();
    if (response && Object.keys(response).length) {
      const { UniquePIN, signupurl, demoNumber } = response;
      if (UniquePIN && signupurl) {
        pushRegInfoToGTM(response);
        setCookie('isregistered', true, 365);
        setCookie('uniquePin', UniquePIN, 365);
        setCookie('demoNumber', demoNumber, 365);
        successCallback();
        if (isFromPartnershipPages && registerLpFrom) {
          registerLpFrom.classList.add('is-registered');
          showPlansFold(UniquePIN);
        } else if (isFromLpPages || isReferAFriendPage) {
          registerLpFrom.classList.add('is-registered');
          btmRegisterLpForm.classList.add('is-registered');
        } else if (window.location.pathname !== '/view-pricing') {
          showPlansFold(UniquePIN);
        }
        window.location.href = '/plans';
      }
    }
  } catch (e) {
    console.error(e); // eslint-disable-line
    window.location.href = '/register';
  }
}

function payloadReducer(prevValue, currentValue) {
  const prevValueRef = prevValue;
  const { value, emittedBy } = currentValue;
  if (emittedBy === 'phone') {
    const { dialCode, nationalNumber } = currentValue;
    prevValueRef.countryCode = dialCode;
    prevValueRef.phone = nationalNumber;
  } else {
    prevValueRef[emittedBy] = value;
  }
  return prevValueRef;
}

function createLeadInfoObj(eventId) {
  if (eventId === 'associate-register-btn') {
    return associationsLeadInfo;
  }
  if (eventId === 'btm-ppc-register') {
    return btmPpcleadInfo;
  }

  return leadInfo;
}

function registrationCTAHandler(event) {
  event.preventDefault();
  const infoObj = createLeadInfoObj(event.target.id);

  if (isLeadInfoValid(infoObj)) {
    event.target.classList.add('processing');
    const payload = Object.values(infoObj).reduce(payloadReducer, {});
    processLeadRegistration({
      ...payload,
      brandid: BRANDID,
      cookie: document.cookie,
      referrer: document.referrer || window.location.href,
      ...(isReferAFriendPage && {
        reference: 'Referral',
        referrerContactId: getCookieValue('referrerContactId'),
      }),
      timezone: window.getUserTimezone && window.getUserTimezone(),
      ...(isFromAANPPage && { leadSource: ' - AANP' }),
      ...(isFromNAHCPage && { leadSource: ' - NAHC' }),
      ...(isFromAMSPAPage && { leadSource: ' - Amspa' }),
      ...(isFromACAPage && { leadSource: ' - ACA' }),
      ...(isFromAADOMPage && { leadSource: ' - AADOM' }),
      ...(isTapNativeCookiePresent() && { leadSource: ' - TapNative' }),
      ...(isFromJoepopPage && { leadSource: ' - POTP' }),
      ...(isFromStartupNationPage && { leadSource: ' - Private practice startup' }),
      ...(isFromIgniteDDSPage && { leadSource: ' - Ignite DDS' }),
      ...(isFromTdaMeeting && { leadSource: ' - TDA Meeting 2024' }),
      ...(isFromMcCancePage && { leadSource: ' - McCance' }),
      ...(isFromDentalpreneurPage && { leadSource: ' - Dentalpreneur' }),
    });
  } else if (infoObj && Object.keys(infoObj).length) {
    highlightInvalidFields(infoObj);
  }
}

if (registerBtn) registerBtn.addEventListener('click', registrationCTAHandler);
if (associateRegisterBtn) associateRegisterBtn.addEventListener('click', registrationCTAHandler);
if (btmPpcregisterBtn) btmPpcregisterBtn.addEventListener('click', registrationCTAHandler);

if (isFromPartnershipPages || isFromLpPages) {
  window.addEventListener('pageshow', () => {
    if (getCookieValue('isregistered')) {
      if (associateRegisterBtn) {
        showPlansFold(getCookieValue('uniquePin'));
      }
      if (registerLpFrom) {
        registerLpFrom.classList.add('is-registered');
      }
      if (btmRegisterLpForm) {
        btmRegisterLpForm.classList.add('is-registered');
      }
    }
  });
}
// Intltel Input Accessibility

window.addEventListener('load', () => {
  setPhoneFlagAttribute();
});
